// Número exibido pra cozinha, admin e operador: o número sequencial do
// pedido dentro do PRÓPRIO estabelecimento (1º, 2º, 3º pedido feito ali...),
// nunca o id_pedido (chave interna do banco, compartilhada entre todos os
// estabelecimentos). Pedidos antigos, de antes dessa coluna existir no
// banco, não têm numero_pedido — nesse caso cai de volta pro id_pedido.
export function numeroExibicaoPedido(pedido) {
  return pedido?.numero_pedido ?? pedido?.id_pedido;
}
